import React, { useState } from 'react';
import {
  Button,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
} from 'reactstrap';
import Wordings from '../../../config/stringTable';
import { postSkipBanking } from '../../../services/scoringService';

import styles from './SkipBankingSurvey.module.scss';

const emptyResponse = { key: 'no-answer', displayText: 'No Answer' };

export default function SkipBankingSurveyView(props) {
  const [selectedReason, setSelectedReason] = useState(emptyResponse);

  if (!props.skipBankingSurvey
    || !props.skipBankingSurvey.enabled
    || !props.skipBankingSurvey.answers) return null;

  const {
    isOpen,
    onClose,
    requestId,
    clientId,
    language = 'en',
  } = props;
  const disableOkButton = !props.allowEmptyResponse && selectedReason === emptyResponse;

  const handleSkipBanking = (didSkip) => {
    if (didSkip) postSkipBanking(clientId, requestId, selectedReason);
    onClose(didSkip);
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={() => onClose(false)}
    >
      <ModalHeader toggle={() => onClose(false)}>
        { Wordings[language]['Are you sure you want to skip banking?'] }
      </ModalHeader>
      <ModalBody className={styles.modalBody}>
        <div className={styles.modalNote}>
          { Wordings[language]['If you still want to skip this step, please let us know why'] }
        </div>
        <div className={styles.choiceContainer} data-cy="skipChoiceList">
          {
              props.skipBankingSurvey.answers.map((choice, index) => (
                <div className={styles.choice} key={choice.key} data-cy="skipChoice">
                  <Label for={`choice-${index}`} check>
                    <Input
                      id={`choice-${index}`}
                      type="radio"
                      name="skipReason"
                      value={choice.key}
                      onClick={() => setSelectedReason(choice)}
                    />
                    {choice.text ? choice.text[language] : choice.displayText}
                  </Label>
                </div>
              ))
            }
        </div>
      </ModalBody>
      <ModalFooter>
        <Button
          color="success"
          disabled={disableOkButton}
          onClick={handleSkipBanking}
          data-cy="skipBankingSubmit"
        >
          { Wordings[language].Submit }
        </Button>
        <Button
          color="secondary"
          onClick={() => onClose(false)}
        >
          { Wordings[language].Cancel }
        </Button>
      </ModalFooter>
    </Modal>
  );
}
